import { render, staticRenderFns } from "./dropDown.vue?vue&type=template&id=008a4572&scoped=true&"
import script from "./dropDown.vue?vue&type=script&lang=js&"
export * from "./dropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008a4572",
  null
  
)

export default component.exports